export let BASE_URL = '';
export let BASE_IMAGE_URL = '';
export let STRIPE_PUBLISHABLE_KEY = '';
export let BASE_APP_URL = '';
export let CLIENT_APP_URL = '';

// eslint-disable-next-line no-undef
if (typeof config !== 'undefined' && config.env === 'prod') {
  BASE_URL = 'https://preventiacosmosvnet.azurewebsites.net/api';
  BASE_IMAGE_URL = 'https://preventiab2e9.blob.core.windows.net/user-profile';
  BASE_APP_URL = 'https://payment.preventiagroup.com';
  STRIPE_PUBLISHABLE_KEY = '';
  CLIENT_APP_URL = 'https://client.preventiagroup.com';
// eslint-disable-next-line no-undef
} else if (typeof config !== 'undefined' && config.env === 'local') {
  BASE_URL = 'http://localhost:7071/api';
  BASE_IMAGE_URL = 'https://preventiab2e9.blob.core.windows.net/user-profile';
  STRIPE_PUBLISHABLE_KEY = 'pk_test_51HwTxDLmvucqMcOUkrSPO0W9CzdZHCX8KCCf3yfvLRIYTEHUb2aciqBSj7hvwPCOlBVA7E0RCKuRA79Kb6WuRxHX00ceTrE1x6';
  BASE_APP_URL = 'http://localhost:8080';
  CLIENT_APP_URL = 'http://localhost:19006';
} else {
  BASE_URL = 'https://preventiadevblue.azurewebsites.net/api';
  BASE_IMAGE_URL = 'https://preventiab2e9.blob.core.windows.net/user-profile';
  STRIPE_PUBLISHABLE_KEY = 'pk_test_51HwTxDLmvucqMcOUkrSPO0W9CzdZHCX8KCCf3yfvLRIYTEHUb2aciqBSj7hvwPCOlBVA7E0RCKuRA79Kb6WuRxHX00ceTrE1x6';
  BASE_APP_URL = 'https://paymentdev.z19.web.core.windows.net';
  CLIENT_APP_URL = 'https://preventiaclientdev.z13.web.core.windows.net/sign-in';
}

export function extractAxiosErrorMessage (error) {
  if (error?.response?.status === 404) {
    return 'Not found';
  } else if (error?.response?.data?.message) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    return error.response.data.message;
  } else if (error?.request && !error?.response) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest
    return 'No response from server';
  } else if (error?.message) {
    // Something happened in setting up the request that triggered an Error, or
    // there was a server error but no helpful message was returned
    return error.message;
  } else if (typeof error === 'string') {
    return error;
  } else {
    return 'There was a network error.';
  }
}
